import * as Styles from './Sidebar.styles';

type SidebarItemType = {
  label: string;
  id: string;
  onClick: () => void;
};

type SidebarType = {
  sidebarMenus: SidebarItemType[];
  title?: string;
  testId?: string;
  className?: string;
};

export default function Sidebar({
  sidebarMenus,
  title = 'Jump to',
  testId,
  className,
}: SidebarType): JSX.Element {
  return (
    <Styles.Sidebar data-testid={testId} className={className}>
      {title && <Styles.SidebarSubtitle>Jump to</Styles.SidebarSubtitle>}
      <ul>
        {sidebarMenus.map((menu) => {
          return (
            <li key={menu.id}>
              <Styles.Section
                key={menu.id}
                data-testid={menu.id}
                onClick={() => menu.onClick()}
                type="button"
              >
                {menu.label}
              </Styles.Section>
            </li>
          );
        })}
      </ul>
    </Styles.Sidebar>
  );
}
